import { useEffect, useState } from 'react';

const COLORS = ['#c9a227', '#e8c75a', '#1a355f', '#2d4c7e', '#ffd54f', '#0d1f3b', '#fff'];

// Confetti burst — fixed-position pieces that fall once. Auto-clears after a few seconds.
function Confetti({ count = 90 }) {
  const [pieces] = useState(() =>
    Array.from({ length: count }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      delay: Math.random() * 0.6,
      dur: 2.4 + Math.random() * 1.8,
      size: 7 + Math.random() * 8,
      round: Math.random() > 0.6,
    }))
  );
  return (
    <>
      {pieces.map(p => (
        <span key={p.id} className="confetti-piece"
          style={{
            left: p.left + 'vw',
            background: p.color,
            width: p.size, height: p.round ? p.size : p.size * 1.4,
            borderRadius: p.round ? '50%' : 2,
            animation: `confettiFall ${p.dur}s ${p.delay}s linear forwards`,
          }} />
      ))}
    </>
  );
}

// Starburst rays behind the mascot
function Rays() {
  return (
    <svg className="victory-rays" viewBox="0 0 200 200" width="320" height="320"
      style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', zIndex: 0 }}>
      {Array.from({ length: 16 }).map((_, i) => {
        const a = (i * Math.PI * 2) / 16;
        return (
          <line key={i} x1="100" y1="100"
            x2={100 + Math.cos(a) * 120} y2={100 + Math.sin(a) * 120}
            stroke={i % 2 ? '#c9a227' : '#e8c75a'} strokeWidth={i % 2 ? 10 : 5} opacity="0.5" strokeLinecap="round" />
        );
      })}
    </svg>
  );
}

/**
 * VictoryCelebration — drops confetti and shows a celebratory hero.
 * Props: score, total, correct, passingScore, pose (mascot pose name)
 */
export default function VictoryCelebration({ score, pose = 'ok' }) {
  const [showConfetti, setShowConfetti] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShowConfetti(false), 5000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      {showConfetti && <Confetti />}
      <div style={{ position: 'relative', height: 230, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', marginBottom: 6 }}>
        <Rays />
      </div>
      <div className="victory-title" style={{ fontSize: 34, fontWeight: 900, color: '#1a355f', letterSpacing: 0.5 }}>
        <span className="victory-badge" style={{ marginRight: 8 }}>🏆</span>PASSED!
      </div>
    </>
  );
}
